import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DescribedImage, Product } from '@planone/bau365/util-fair-data';
import { SwiperInteractionEvent } from '@planone/shared/data-access-swiper';
import { BreadcrumbElement } from '@planone/shared/ui-elements';

@Component({
  selector: 'bau365-product-section-header',
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss'],
})
export class SectionProductHeaderComponent {
  @Input() fairId?: string;
  @Input() product?: Product;
  @Input() breadcrumbElements?: BreadcrumbElement[] | undefined;
  @Input() breadcrumbClickable = true;
  @Input() isPlatformFair = true;
  @Input() featureProductAtBooth = false;

  @Output() swiperInteraction: EventEmitter<SwiperInteractionEvent> = new EventEmitter<SwiperInteractionEvent>();
  @Output() shareButtonDialogOpen: EventEmitter<Event> = new EventEmitter<Event>();

  trackSwiperInteraction = (event: SwiperInteractionEvent) => this.swiperInteraction.emit(event);

  trackShareButtonDialogOpened = (event: Event) => this.shareButtonDialogOpen.emit(event);

  identifyImage(_index: number, image: DescribedImage): string {
    return `${image.provider}/${image.resource}`;
  }
}
